import Navbar from './Navbar.vue'
import './navbar.scss'

export default Navbar
